import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/font_3864161_vs7k2rrmad9.css';
import './assets/css/animate.css';
import './assets/css/f-style.css';
import './assets/css/style.css';
import './assets/css/bootstrap.min.css';
import './assets/js/jquery.js';
import './assets/js/bootstrap.min.js';
import './style/index.less'
import { uploadFile } from './api';
import axios from 'axios';
import store from './store/inxex'
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
import './assets/unit/configure.js';

//自定义指令
Vue.directive('edit', {
    //编辑当前标签内容
    bind(el, binding, vnode) {
        var that = vnode.context;
        if (store.state.token) {
            el.addEventListener('click', function() {
                event.stopPropagation();
                that.$prompt('请输入要替换的内容', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
                    .then(({ value }) => {
                        el.innerText = value;
                        binding.value.form[binding.value.key] = value;
                    })
                    .catch(() => {
                        that.$message({
                            type: 'info',
                            message: '取消输入'
                        });
                    });
            });
        }
    }
});
Vue.directive('img', {
    // 编辑当前图片
    bind(el, binding, vnode) {
        if (store.state.token) {
            var that = vnode.context;
            el.addEventListener('click', function() {
                event.stopPropagation();
                let input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', '.png,.jpg');
                input.click();
                input.onchange = function() {
                    const formData = new FormData();
                    formData.append('file', this.files[0]);
                    uploadFile(formData)
                        .then(res => {
                            binding.value.form[binding.value.key] = res.data;
                            that.$set(binding.value.form, binding.value.key, res.data);
                        })
                        .catch(() => {
                            that.$message({
                                type: 'info',
                                message: '上传失败，请重试'
                            });
                        });
                };
            });
        }
    }
});

// import $ from 'jquery';
// window.$ = $;
/* 路由守卫 */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
